<div class="relative dashboard-box lg:col-span-2">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <!-- Header -->
    <div class="px-8 sm:px-10 py-3 flex items-center justify-between dashboard-header">
      <h2 class="text-xl text-white font-semibold mb-0">Facturación CDR (CPaaS)</h2>
      <span class="text-xs text-white/60">digitalservices.wholesale.telekom.com</span>
    </div>

    <div class="px-6 lg:px-10 py-6 flex flex-col gap-6">

      <!-- Token status -->
      <div *ngIf="accessToken" class="flex items-center gap-3 text-sm flex-wrap">
        <span [class]="tokenStatusClass">●</span>
        <span [class]="tokenStatusClass">{{ tokenStatusLabel }}</span>
        <button mat-stroked-button (click)="refreshAccessToken()" [disabled]="loading"
                class="!text-xs !py-0 !px-2 !h-7">
          Refrescar token
        </button>
        <button mat-stroked-button color="warn" (click)="clearSession()" [disabled]="loading"
                class="!text-xs !py-0 !px-2 !h-7">
          Cerrar sesión
        </button>
      </div>

      <!-- ── 1. Autenticación ── -->
      <mat-expansion-panel [expanded]="!accessToken">
        <mat-expansion-panel-header>
          <mat-panel-title class="font-semibold">1. Autenticación</mat-panel-title>
          <mat-panel-description>OAuth2 — grant_type=password</mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex flex-col gap-4 pt-2">
          <div class="flex flex-wrap gap-4">
            <mat-form-field class="flex-1 min-w-[180px]">
              <mat-label>Usuario (Digital Services Portal)</mat-label>
              <input matInput [(ngModel)]="username" autocomplete="username">
            </mat-form-field>
            <mat-form-field class="flex-1 min-w-[180px]">
              <mat-label>Contraseña</mat-label>
              <input matInput type="password" [(ngModel)]="password" autocomplete="current-password">
            </mat-form-field>
            <mat-form-field class="w-[140px]">
              <mat-label>OTP (si aplica)</mat-label>
              <input matInput [(ngModel)]="otp" autocomplete="one-time-code">
            </mat-form-field>
          </div>
          <div>
            <button mat-raised-button color="primary" (click)="login()" [disabled]="loading">
              <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
              Iniciar sesión
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- ── 2. Selección de facturación ── -->
      <mat-expansion-panel [expanded]="!!accessToken">
        <mat-expansion-panel-header>
          <mat-panel-title class="font-semibold">2. Selección de facturación</mat-panel-title>
          <mat-panel-description>Cliente, período y parámetros</mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex flex-col gap-4 pt-2">

          <!-- Fila 1: cliente + mes + año -->
          <div class="flex flex-wrap gap-4">
            <mat-form-field class="flex-1 min-w-[200px]">
              <mat-label>Cliente</mat-label>
              <mat-select [(ngModel)]="selectedClient">
                <mat-option *ngFor="let c of clientOptions" [value]="c">{{ c.label }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-[160px]">
              <mat-label>Mes</mat-label>
              <mat-select [(ngModel)]="selectedMonth">
                <mat-option *ngFor="let m of months" [value]="m.value">{{ m.label }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-[100px]">
              <mat-label>Año</mat-label>
              <mat-select [(ngModel)]="selectedYear">
                <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Fila 2: categoría + precio -->
          <div class="flex flex-wrap gap-4">
            <mat-form-field class="w-[220px]">
              <mat-label>Categoría</mat-label>
              <mat-select [(ngModel)]="category">
                <mat-option *ngFor="let cat of categories" [value]="cat">{{ cat }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w-[180px]">
              <mat-label>Precio por SMS (€)</mat-label>
              <input matInput type="number" [(ngModel)]="pricePerSms" step="0.00001" min="0">
            </mat-form-field>
          </div>

          <div>
            <button mat-raised-button color="primary" (click)="generate()"
                    [disabled]="loading || !accessToken || !selectedClient">
              <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
              ▶ Generar facturación
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- ── 3. Log de ejecución ── -->
      <mat-expansion-panel [expanded]="logMessages.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title class="font-semibold">3. Log de ejecución</mat-panel-title>
          <mat-panel-description *ngIf="logMessages.length === 0">sin ejecuciones aún</mat-panel-description>
        </mat-expansion-panel-header>

        <div class="pt-2">
          <pre *ngIf="logMessages.length > 0"
               class="bg-gray-50 border border-gray-200 rounded p-4 text-gray-700 max-h-96 overflow-y-auto">{{ logText }}</pre>
          <p *ngIf="logMessages.length === 0" class="text-sm text-gray-400 py-2">
            Pulsa "Generar facturación" para iniciar el proceso.
          </p>
        </div>
      </mat-expansion-panel>

      <!-- Error -->
      <div *ngIf="lastError" class="bg-red-50 border border-red-200 rounded p-4">
        <p class="text-xs font-semibold text-red-700 mb-1">Error</p>
        <pre class="text-red-600">{{ lastError }}</pre>
      </div>

    </div>
  </div>
  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>
